import { useGlobalStore } from "../../common";

export function useAiSetting(){
    const settings = useGlobalStore((state) => state.settings.data);
    return settings?.find( x => x.name === 'Enable AI' )?.value === 'true';
}
